
import {NSGoTo} from './go_to';


export let NSStartupAction = {}

/**
 * @returns promise
 */
NSStartupAction.init = function()
{
    NSStartupActionPrivate.init();


    this.f_get_label_by_internal_name =         function () { return NSStartupActionPrivate.f_get_label_by_internal_name.apply( NSStartupActionPrivate, arguments ); };
    this.f_get_label_text_by_internal_name =    function () { return NSStartupActionPrivate.f_get_label_text_by_internal_name.apply( NSStartupActionPrivate, arguments ); };

  


    window.NSStartupAction_ = NSStartupAction;
    window.NSStartupActionPrivate_ = NSStartupActionPrivate;

}


let NSStartupActionPrivate = 
{
    private_objs:
    {
        a_validUrlParameters: [ "urn" ],
          
	    activeUrlParameters : {},
        
    },

	
	init : function() {
		this.parseUrlParameters();
	},
	
	parseUrlParameters : function() {
        let private_objs = this.private_objs;
        let a_validUrlParameters = private_objs.a_validUrlParameters;
        let activeUrlParameters = private_objs.activeUrlParameters;

		let sPageURL = window.location.search.substring(1);
		let sURLVariables = sPageURL.split('&');
		
		for (let i = 0; i < sURLVariables.length; i++) {
			let a_parameter_i = sURLVariables[i].split('=');
			if( a_validUrlParameters.includes( a_parameter_i[0] ) ){
				activeUrlParameters[ a_parameter_i[0] ] = decodeURIComponent(a_parameter_i[1])
			}
		}
		
		if(  Object.keys(activeUrlParameters).length > 0 ) {
			this.gotoAsset();
		} 
		
	},
	
	gotoAsset : function(){	
        let private_objs = this.private_objs;
        let activeUrlParameters = private_objs.activeUrlParameters;
        	
		for ( let key in activeUrlParameters) {
			switch(key){
				case "urn" : 
					this.gotoUrn( activeUrlParameters[key] );
					break;
			}
		}
	},
	
	gotoUrn : function( s_record_urn )
    {

        NSGoTo.f_go_to_urn(s_record_urn);

	}


    


}